import { Component, Input, OnInit } from '@angular/core';
import { NotificationType } from './notification.interface';
import { Subject } from 'rxjs';

@Component({
  selector: 'vm-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnInit {
  @Input() type: NotificationType;
  @Input() dismissable: Subject<boolean>;
  @Input() messageImageSrc: string;
  @Input() messageImageAlt: string;
  @Input() autoDestructMiliseconds: Subject<number>;
  show: boolean;
  private timer;

  ngOnInit() {
    if (this.autoDestructMiliseconds) {
      this.autoDestructMiliseconds.subscribe((value) => {
        if (value > 0) {
          this.show = true;
          if (this.timer) {
            clearTimeout(this.timer);
          }
          this.timer = setTimeout(() => {
            this.closeDialog();
          }, value);
        } else {
          this.show = false;
        }
      });
    }
    if (this.dismissable) {
      this.dismissable.subscribe((value) => {
        this.show = value;
      });
    }
    if (!this.autoDestructMiliseconds && !this.dismissable) {
      this.show = true;
    }
  }

  public closeDialog() {
    this.show = false;
    if (this.dismissable) {
      this.dismissable.next(false);
    }
    if (this.autoDestructMiliseconds) {
      this.autoDestructMiliseconds.next(0);
    }
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
